<template>
  <div class="comment-panel">
    <!-- <div class="comment-panel-header">
      <div class="comment-panel-header--title">Comments</div>
      <img src="~@/assets/images/icons/close-icon.svg" @click="$emit('closeComment')" width="20px" alt="" />
    </div> -->
    <div class="comment-panel-container">
      <div class="fh fw center" v-if="loading">
        <loading-circle />
      </div>
      <div
      v-else-if="comments.length === 0"
       class="fh fw center"
    >
      <span class="text-muted">No Comments</span>
    </div>
      <template v-else>
        <comment-card
          v-for="comment in comments"
          :commentData="comment"
          :key="comment.id"
          :level="3"
          @updateComment="getComments"
        />
      </template>
    </div>
    <div class="comment-panel-comment-box flex">
      <div
        contenteditable="true"
        class="comment-panel-comment-box--editor"
        @keyup="setMessage"
        ref="editor"
      ></div>
      <spinner class="spinner" v-if="commentSending"></spinner>
      <img
        v-else
        @click="sendComment"
        src="~@/assets/images/icons/send-icon.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { addComments, getAllFormComments } from '@/api'
import commentCard from './commentCard.vue'
import LoadingCircle from '../common/loadingCircle.vue'
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'formCommentPanel',
  components: { commentCard, LoadingCircle, Spinner },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      commentSending: false,
      comment: '',
      loading: false,
      comments: []
    }
  },
  methods: {
    setMessage (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.target.innerText += '\n'
        return
      }
      if (e.keyCode === 13) {
        this.sendComment()
        return
      }
      this.comment = e.target.innerText
    },
    sendComment () {
      if (this.commentSending) return
      this.commentSending = true
      if (!this.comment.trim()) {
        this.commentSending = false
        return
      }
      addComments('form', this.form.id, this.comment, null).finally(
        () => {
          this.comment = ''
          this.$refs.editor.innerText = ''
          this.getComments()
          this.commentSending = false
        }
      )
    },
    getComments () {
      this.loading = true
      if (this.form.id) {
        getAllFormComments(this.form.id, null)
          .then((res) => {
            this.comments = res.core_comments || []
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.$emit('closeComment')
      }
    }
  },
  watch: {
    form () {
      this.getComments()
    }
  },
  mounted () {
    this.getComments()
    if (this.closeOnOutsideClick) {
      document.addEventListener('mousedown', this.handleClickOutside)
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style lang="scss" scoped>
.comment-panel {

  .spinner {
    margin-bottom: 4px;
    padding: 4px;
    width: 32px;
    height: 32px;
  }
  height: calc(100vh - 270px);
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 6px;
  background-color: var(--bg-color);
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
    margin: -6px;
    margin-bottom: 12px;
    background-color: var(--brand-color);
    &--title {
      font-size: var(--text-base);
      font-weight: 500;
      color: var(--text-color);
    }
    img {
      cursor: pointer;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
  }
  &-container {
    flex-grow: 1;
    height: 49.5vh;
    overflow-y: auto;
    margin-right: -6px;
    padding-right: 6px;
  }
  &-comment-box {
    padding: 10px;
    margin: -6px;
    margin-top: 0px;
    width: calc(100% + 12px);
    background-color: var(--bg-color);
    align-items: flex-end;
    gap: 10px;
    &--editor {
      width: 100%;
      min-height: 40px;
      padding: 10px;
      outline: none;
      border: 1px solid var(--brand-color);
      border-radius: 4px;
      resize: none;
      max-height: 100px;
      overflow: auto;
      font-size: var(--text-s);
      font-weight: 400;
      line-height: 1.2;
      background-color: var(--white);
      color: var(--text-color);
      &:focus {
        outline: none;
      }
    }
    img {
      width: 32px;
      height: 32px;
      cursor: pointer;
      opacity: 0.8;
      margin-bottom: 4px;
      padding: 4px;
      border-radius: 50%;
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
